export const EDIT_PROFILE = "EDIT_PROFILE";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const RESET_PROFILE_FLAG = "RESET_PROFILE_FLAG";
export const UPDATE_USER_PERMISSION = "UPDATE_USER_PERMISSION";
export const PERMISSION_ACCOUNT = "PERMISSION_ACCOUNT";
